import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/varietyData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-clapperboard-line text-2xl text-primary-500"></i>
            </div>
            <span
              className={`text-xl font-heading font-bold transition-colors ${
                isScrolled ? 'text-foreground-900' : 'text-white'
              }`}
            >
              香蕉影视
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${
                location.pathname === '/'
                  ? isScrolled
                    ? 'text-primary-500'
                    : 'text-white'
                  : ''
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/80 hover:text-white'
              } ${
                location.pathname === '/about'
                  ? isScrolled
                    ? 'text-primary-500'
                    : 'text-white'
                  : ''
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <form onSubmit={handleSearchSubmit} className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索综艺..."
                className={`text-sm pl-9 pr-4 py-2 rounded-full border transition-all w-48 focus:w-64 outline-none ${
                  isScrolled
                    ? 'bg-background-100 border-background-200 text-foreground-800 placeholder-foreground-400'
                    : 'bg-white/15 border-white/20 text-white placeholder-white/50'
                }`}
              />
              <button type="submit" className="absolute left-3 top-1/2 -translate-y-1/2 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i
                    className={`ri-search-line text-sm ${
                      isScrolled ? 'text-foreground-400' : 'text-white/60'
                    }`}
                  ></i>
                </div>
              </button>
            </form>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden cursor-pointer"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <i
                className={`text-xl ${
                  isScrolled ? 'text-foreground-800' : 'text-white'
                } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </div>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium py-2 text-foreground-700"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium py-2 ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
            <form onSubmit={handleSearchSubmit} className="relative mt-2">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索综艺..."
                className="text-sm w-full pl-9 pr-4 py-2 rounded-full border border-background-200 bg-background-100 text-foreground-800 placeholder-foreground-400 outline-none"
              />
              <button type="submit" className="absolute left-3 top-1/2 -translate-y-1/2 cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-search-line text-sm text-foreground-400"></i>
                </div>
              </button>
            </form>
          </div>
        </div>
      )}
    </nav>
  );
}